import { render } from "./TopEmotionCards.vue?vue&type=template&id=0ce5b72d&scoped=true"
import script from "./TopEmotionCards.vue?vue&type=script&lang=js"
export * from "./TopEmotionCards.vue?vue&type=script&lang=js"

import "./TopEmotionCards.vue?vue&type=style&index=0&id=0ce5b72d&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ce5b72d"]])

export default __exports__